// RouteComponents.jsx
import { Routes, Route } from "react-router-dom";
import ErrorPage from "./pages/404";
import BoardRoute from "@dashboard/board/RouteMap";
import SettingRoute from "@dashboard/settings/RouteMap";
import Landing from "@landing/Home";
import BookingRooute from "@dashboard/bookings/RouteMap";
import VoucherPage from "@dashboard/bookings/voucher/VoucherPage";
import ProductRoute from "@dashboard/products/RouteMap";
import ClientRoute from "@dashboard/clients/RouteMap";
import NetworkRoute from "@dashboard/networks/RouteMap";
import ChatRoute from "@dashboard/chat/RouteMap";
import UserRoute from "@dashboard/users/RouteMap";
import TicketRoute from "@dashboard/tickets/RouteMap";
import InvoiceRoute from "@dashboard/invoices/InvoiceRoute";
import AuthRooute from "@auth/RouteMap";
import DashboardLayout from "@dashboard/DashboardLayout";
import DashboardProductLayout from "@dashboard/DashboardProductLayout";
import DashboardMain from "@newProduct/DashboardMain";
import DashboardMainLayout from "@newProduct/DashboardMainLayout";
import HomeRoute from "@landing/HomeRoute";
import HomeLayout from "@landing/HomeLayout";


function RouteComponents() {
  return (
    <Routes>
      {/* <Route path="/" element={<Landing />} /> */}
      <Route path="/" element={<AuthRooute component="login" />} />
      <Route element={<HomeLayout />}>
      <Route path="/home" element={<Landing />} />
        <Route path="about" element={<HomeRoute component="about" />} />
        <Route path="features" element={<HomeRoute component="features" />} />
        <Route path="jobs" element={<HomeRoute component="jobs" />} />
        <Route path="solutions" element={<HomeRoute component="solutions" />} />
        <Route path="pricing" element={<HomeRoute component="pricing" />} />
        <Route path="contact" element={<HomeRoute component="contact" />} />
        <Route path="live_chat" element={<HomeRoute component="livechat" />} />
        <Route path="help_desk" element={<HomeRoute component="helpdesk" />} />
        <Route path="travel_alerts" element={<HomeRoute component="travelalerts" />} />
        <Route path="travel_guides" element={<HomeRoute component="travel_guides" />} />
        <Route path="tips" element={<HomeRoute component="tips" />} />
        <Route path="contact" element={<HomeRoute component="contact" />} />
        <Route path="api_developers" element={<HomeRoute component="apidevelopers" />} />
        <Route path="FAQ" element={<HomeRoute component="faq" />} />
        <Route path="newsletter" element={<HomeRoute component="newsletter" />} />
        <Route path="privacy_policy" element={<HomeRoute component="privacypolicy" />} />
        <Route path="terms_and_conditions" element={<HomeRoute component="terms_and_conditions" />} />
        <Route path="join_us" element={<HomeRoute component="join_us" />} />
      </Route>
     

      <Route path="/login" element={<AuthRooute component="login" />} />
      <Route
        path="/recover-password/:token"
        element={<AuthRooute component="recover" />}
      />
      {/* Dashboard with nested routes */}
      <Route element={<DashboardLayout />}>
        <Route path="dashboard" element={<BoardRoute component="home" />} />
        <Route path="settings" element={<SettingRoute component="home" />} />
        <Route path="invoices" element={<InvoiceRoute component="home" />} />
        <Route path="clients" element={<ClientRoute component="home" />} />
        <Route path="networks" element={<NetworkRoute component="home" />} />
        <Route path="chat" element={<ChatRoute component="home" />} />
        <Route path="/bookings">
          <Route path="" element={<BookingRooute component="home" />} />
          <Route path="" element={<BookingRooute component="search" />} />
          <Route path="" element={<BookingRooute component="detail" />} />
        </Route>
        <Route path="/voucher/:id" element={<VoucherPage />} />


        <Route path="/users">
          <Route path="" element={<UserRoute component="home" />} />
          <Route path=":id" element={<UserRoute component="profile" />} />
        </Route>
        <Route path="/tickets">
          <Route path="" element={<TicketRoute component="home" />} />
          <Route path=":id" element={<TicketRoute component="detail" />} />
        </Route>
        <Route path="/products">
          <Route path="" element={<ProductRoute component="home" />} />
        </Route>

      </Route>

      <Route element={<DashboardProductLayout />}>
        <Route path="/products">
          <Route
            path=":id/:country/:service/:name"
            element={<ProductRoute component="detail" />}
          />
          <Route
            path=":id/:country/:service/:name/availability"
            element={<ProductRoute component="availability" />}
          />
          <Route
            path=":id/:country/:service/:name/informations"
            element={<ProductRoute component="informations" />}
          />
          <Route
            path=":id/:country/:service/:name/promotions"
            element={<ProductRoute component="promotions" />}
          />
          <Route
            path=":id/:country/:service/:name/album"
            element={<ProductRoute component="album" />}
          />
          <Route
            path=":id/:country/:service/:name/room-types-and-price-levels"
            element={<ProductRoute component="roomTypesAndPriceLevels" />}
          />

          <Route
            path=":id/:country/:service/:name/pricing-options-and-availability"
            element={<ProductRoute component="pricingOptionsAndAvailability" />}
          />

          <Route
            path=":id/:country/:service/:name/restrictions"
            element={<ProductRoute component="restrictions" />}
          />
          <Route
            path=":id/:country/:service/:name/cancellation-policy"
            element={<ProductRoute component="cancellationPolicy" />}
          />
          <Route
            path=":id/:country/:service/:name/accupancy-and-fees"
            element={<ProductRoute component="accupancyAndFees" />}
          />
          <Route
            path=":id/:country/:service/:name/availability_updates_by_block"
            element={<ProductRoute component="AvailabilityUpdatesByBblock" />}
          />
          <Route
            path=":id/:country/:service/:name/rate-automatic"
            element={<ProductRoute component="rateAutomatic" />}
          />
        </Route>
      </Route>

      <Route element={<DashboardMainLayout />}>
        <Route
          path="/new-product/form"
          element={<DashboardMain component="hosting" />}
        />
        <Route
          path="/new-product/type"
          element={<DashboardMain component="structure" />}
        />
        <Route
          path="/new-product"
          element={<DashboardMain component="structure" />}
        />
      </Route>
      <Route path="*" element={<ErrorPage />} />
    </Routes>
  );
}

export default RouteComponents;
